/**
 * Local/session storage keys - URS referral app
 */

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  TOKEN_EXPIRY: 'tokenExpiry',
  USER_DATA: 'urs_referral_user',
  PERMISSIONS: 'urs_referral_permissions',
  REMEMBER_ME: 'urs_referral_remember_me',
  THEME: 'urs_referral_theme',
  LANGUAGE: 'urs_referral_language',
  SIDEBAR_COLLAPSED: 'urs_referral_sidebar_collapsed',
  LAST_ROUTE: 'urs_referral_last_route',
  FORM_DATA: 'urs_referral_form_data',
} as const;
